<template lang="pug">
div(ref="canvasContainer")
</template>

<script>
import * as THREE from "three";

export default {
  props: {
    canvasScale: { type: Number, default: 1 },
  },
  created() {
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
    });
    this.canvas = this.renderer.domElement;
    this.scene = new THREE.Scene();
    const camera = (this.camera = new THREE.PerspectiveCamera(
      45,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    ));
    this.camera.position.set(6, 1.75, 4);
    this.camera.lookAt(0, 0, 0);

    this.resizeCanvas = () => {
      const container = this.$refs.canvasContainer;
      const width = container.offsetWidth;
      const height = container.offsetHeight;
      this.renderer.setSize(
        this.canvasScale * width,
        this.canvasScale * height
      );
      this.canvas.style.width = "100%";
      this.canvas.style.height = "100%";

      camera.aspect = width / height;
      camera.updateProjectionMatrix();

      this.$emit("resizeCanvas", width, height);
    };

    window.addEventListener("resize", this.resizeCanvas);
  },
  mounted() {
    this.$refs.canvasContainer.replaceChildren(this.canvas);
    this.resizeCanvas();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeCanvas);
    this.renderer.dispose();
  },
  methods: {
    render() {
      this.renderer.render(this.scene, this.camera);
    },
  },
};
</script>